// localStorage size calculation constants
const LOCAL_STORAGE_OVERHEAD_KB = 3; // Estimated overhead for localStorage metadata
const BITS_PER_CHARACTER = 16; // UTF-16 encoding uses 2 bytes (16 bits) per character
const BITS_PER_BYTE = 8;
const BYTES_PER_KB = 1024;
const KB_PER_MB = 1024;

export const setLocalStorageItem = (
	key: string,
	newValue: string,
	eventHandled = false
) => {
	const oldValue = localStorage.getItem(key);
	localStorage.setItem(key, newValue);

	const event = new StorageEvent('storage', {
		key,
		oldValue,
		newValue: newValue,
	});

	if (!eventHandled) {
		window.dispatchEvent(event);
	}
};

const getLocalStorageSizeKB = () => {
	let allStrings = '';
	for (const key in window.localStorage) {
		// eslint-disable-next-line no-prototype-builtins
		if (window.localStorage.hasOwnProperty(key)) {
			allStrings += window.localStorage[key];
		}
	}
	return allStrings
		? LOCAL_STORAGE_OVERHEAD_KB +
				(allStrings.length * BITS_PER_CHARACTER) /
					(BITS_PER_BYTE * BYTES_PER_KB)
		: 0;
};

/**
 * Get localStorage size in MB
 */
export const getLocalStorageSizeMB = (): number => {
	if (typeof window === 'undefined') return 0;
	return getLocalStorageSizeKB() / KB_PER_MB;
};
